import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { isMenuPageWithheld } from '@/config/fabricaNavigation';
import { useFabricaMenuPaths } from '@/hooks/useNavigation';
import { useRole } from '@/hooks/useRole';

/**
 * Pages follow the role's Fabrica menus (DebtCollectify's RequireMenu): a page under a menu
 * the role has lost shows "no access" instead. Pages under no menu at all, and every page
 * while the menus are not loaded (sample data), open as before. The API still checks each call.
 */
export function MenuAccessGuard() {
  const { roleCode } = useRole();
  const { pathname } = useLocation();
  const paths = useFabricaMenuPaths(roleCode);

  if (paths && isMenuPageWithheld(paths, pathname)) return <NoMenuAccess />;
  return <Outlet />;
}

function NoMenuAccess() {
  const { home } = useRole();
  return (
    <Box
      sx={{
        minHeight: '60dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
      }}
    >
      <Typography variant="h2" component="h1">
        You don’t have access to this page
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
        Your role doesn’t include this menu. Ask your school administrator if you need it.
      </Typography>
      <Button component={RouterLink} to={home} variant="contained" sx={{ mt: 1 }}>
        Go to dashboard
      </Button>
    </Box>
  );
}
